var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"random-recipes"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"list-group list-group-flush"},_vm._l((_vm.recipes),function(recipe){return _c('a',{staticClass:"list-group-item list-group-item-action",attrs:{"href":'/recipes/' + recipe.slug,"title":recipe.name}},[_vm._v(_vm._s(recipe.name))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }